<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Enlaces de youtube
    </h4>
    <hr>

    <div class="form-group row">

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">URL youtube</label>
            <textarea class="form-control" formControlName="urls" autocomplete="off"
                [class.is-invalid]="campoNoValido('urls')" rows="6" [value]="getFormattedUrls()"
                (input)="onUrlInputChange()"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('urls')">Este campo es requerido</small>
            <div class="small-message">
                {{ errorMessage }}
            </div>
        </div>
        <div class="col-12 text-end">
            <button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseWidthExample" aria-expanded="false" aria-controls="collapseWidthExample">
                <i class="fa fa-question-circle" aria-hidden="true"></i>
            </button>
            <div>
                <div class="collapse width text-start" id="collapseWidthExample">
                    <div class="card bg-light">
                        <ol>
                            <ul>1. Abre YouTube en tu navegador web.</ul>
                            <ul>2. Busca el video de YouTube que deseas incorporar en tu sitio web.</ul>
                            <ul>3. Haz clic en el video para abrirlo.</ul>
                            <ul>4. Debajo del video, verás una serie de botones, incluyendo "Compartir". Haz clic en el
                                botón
                                "Compartir".</ul>
                            <ul>5. Haz clic en el botón "Insertar" en la parte superior de la ventana emergente.</ul>
                            <ul>6. Visualizarás un código de la forma:
                                <code>
                        &lt;iframe width="560" height="315"
                        src="<b>https://www.youtube.com/embed/NxSFTiPSY1s?si=_d0Id2Qrp7JCLXNj</b>" 
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; 
                        clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen&gt;&lt;/iframe&gt;
                    </code>
                            </ul>
                            <ul>7. Selecciona solo la parte de
                                <b>https://www.youtube.com/embed/NxSFTiPSY1s?si=_d0Id2Qrp7JCLXNj</b>
                                Este es nuestro código embed de YouTube que deberás copiar en tu caja de texto del
                                observatorio.
                            </ul>
                            <ul>8. En caso de tener más de una URL EMBED de YouTube, repite el proceso, copiando el
                                código
                                después de hacer Enter por cada registro.</ul>
                            <ul>9. Por último, con todos nuestros registros listos, procedemos a guardar utilizando el
                                botón
                                "Guardar".</ul>

                        </ol>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>